import {useEffect, useRef, useState} from "react"
import {Link, useLocation} from "react-router-dom"
import {HashLink} from "react-router-hash-link"
import {pagePaths} from "../Seo/Seo"

export default function Header() {
    const [expanded, setExpanded] = useState(false)
    const header = useRef(null)
    const toggle = useRef(null)
    const location = useLocation()
    const currentPage = location.pathname === "/" ? "/" : location.pathname.replace(/\/+$/, "") + "/"
    const calculatorPage = pagePaths.includes(currentPage) && currentPage !== "/policy/" ? currentPage : "/"
    const close = () => setExpanded(false)
    useEffect(() => { setExpanded(false) }, [location.pathname, location.hash])
    useEffect(() => {
        if (!expanded) return
        const escape = event => {
            if (event.key === "Escape") { event.preventDefault(); setExpanded(false); toggle.current?.focus() }
        }
        const outside = event => { if (!header.current?.contains(event.target)) setExpanded(false) }
        const desktop = window.matchMedia("(min-width: 849px)")
        const resize = event => { if (event.matches) setExpanded(false) }
        document.addEventListener("keydown", escape)
        document.addEventListener("pointerdown", outside)
        desktop.addEventListener("change", resize)
        return () => {
            document.removeEventListener("keydown", escape)
            document.removeEventListener("pointerdown", outside)
            desktop.removeEventListener("change", resize)
        }
    }, [expanded])

    return (
        <header ref={header} className="fleeka-header55" onBlur={event => {
            if (event.relatedTarget && !event.currentTarget.contains(event.relatedTarget)) close()
        }}>
            <div className="fleeka-header55__inner">
                <Link to="/" className="navbar__brand fleeka-brand55" aria-label="Флика — главная">
                    <img className="fleeka-brand55__image" src="/logo/fleeka-logo-new.png" alt="Флика" width="144" height="50" />
                </Link>
                <div className="fleeka-header55__actions">
                    <nav className="fleeka-header55__desktop" aria-label="Основная навигация">
                        <a href="/routes/">Маршруты</a>
                        <HashLink smooth to={calculatorPage + "#qq-trip-calculator"}>Рассчитать стоимость</HashLink>
                        <HashLink smooth to="/#help">Помощь</HashLink>
                        <HashLink smooth to="/#contacts">Контакты</HashLink>
                    </nav>
                    <a className="fleeka-header55__call" href="tel:+79507007071">8 950 700-70-71</a>
                    <button ref={toggle} type="button" className="fleeka-header55__toggle"
                        aria-label={expanded ? "Закрыть меню" : "Открыть меню"}
                        aria-expanded={expanded} aria-controls="fleeka-mobile-navigation"
                        onClick={() => setExpanded(value => !value)}>
                        <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
                            <line className="fleeka-menu55-top" x1="3" y1="6" x2="21" y2="6" />
                            <line className="fleeka-menu55-middle" x1="3" y1="12" x2="21" y2="12" />
                            <line className="fleeka-menu55-bottom" x1="3" y1="18" x2="21" y2="18" />
                        </svg>
                    </button>
                </div>
            </div>
            <nav id="fleeka-mobile-navigation" className="fleeka-header55__mobile" aria-label="Мобильная навигация" hidden={!expanded}>
                <div className="fleeka-header55__links">
                    <Link to="/" onClick={close}>Главная</Link>
                    <a href="/routes/" onClick={close}>Маршруты</a>
                    <HashLink smooth to={calculatorPage + "#qq-trip-calculator"} className="fleeka-header55__calculate" onClick={close}>Рассчитать стоимость</HashLink>
                    <HashLink smooth to="/#help" onClick={close}>Помощь</HashLink>
                    <HashLink smooth to="/#contacts" onClick={close}>Контакты</HashLink>
                    <Link to="/policy/" onClick={close}>Пользовательское соглашение</Link>
                </div>
            </nav>
        </header>
    )
}
